export default {"src":"/_next/static/media/semi-detached-farmhouses-icon.b0622d70.svg","height":88,"width":111,"blurWidth":0,"blurHeight":0};